// Matches the legacy `St` atom. Centered stat block with value, label, optional sub-line.

interface StatProps {
  label: string;
  value: string | number;
  color?: string;
  sub?: string;
}

export function Stat({ label, value, color, sub }: StatProps) {
  return (
    <div className="text-center">
      <div
        className="text-[28px] font-bold font-display leading-none"
        style={{ color: color ?? "rgb(var(--color-accent))" }}
      >
        {value}
      </div>
      <div className="text-[10px] text-muted font-mono uppercase tracking-[0.08em] mt-[6px]">
        {label}
      </div>
      {sub && (
        <div className="text-[10px] text-dim font-mono mt-[2px]">{sub}</div>
      )}
    </div>
  );
}
